export const ERROR_CODE = {
  "OTP_EXCEED" : "CLI-GW-036",
  "OTP_BAN" : "CLI-GW-043",
  "WITHDRAW_PENDING" : "CLI-GW-052",
  "FRONT_INTERNAL" : "FRONT-099",
}